import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "reasonstoreturn",
  inputs: [
    {
      name: "home_country",
      label: "Home Country",
      placeholder: "India",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      // description: "Please write your current country for best results.",
      required: true,
    },
    {
      name: "country",
      label: "Destination Country",
      placeholder: "Australia",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 200,
      //  description: "Please write in the format Canada, Australia, England",
    },
    {
      name: "visa_type",
      label: "Through which you travelled ?",
      placeholder: "Visitor visa , Tourist visa",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      // description:
      //   "Write in the format Visitor visa for Australia,Tourist visa for Canada",
    },
    {
      name: "purpose",
      label: "For what purpose you are travelling?",
      placeholder: "Family Visit ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
  ],
};

export default formFields;
